import _ from 'lodash'
import {
  closeDialog,
  loadingDialog,
  openDialog,
} from 'src/redux/slices/alertDialog'
import {
  getScormDebugSession,
  getScormWorkaround,
} from '../../LeftPanel/MediaDisplay/Scorm/scormDebug'

export const REPORT_COOLDOWN_MS = 60000

const copyText = (text) => {
  try {
    navigator.clipboard.writeText(text).catch(() => {})
  } catch (e) {
    // เบราว์เซอร์ไม่รองรับ clipboard ผู้เรียนยังอ่านรหัสจาก dialog ได้
  }
}

export const handleApplyScormWorkaround = (workaround) => (dispatch) => {
  const session = getScormDebugSession()
  const matched = session ? session.applyWorkaround(workaround) : 0
  if (matched > 0) {
    dispatch(closeDialog())
    return
  }
  dispatch(
    openDialog({
      iconType: 'error',
      title: 'ไม่พบปุ่มเรียนใหม่ในหน้านี้',
      message: ['กรุณาแจ้งรหัสอ้างอิงกับผู้ดูแลระบบ'],
      buttonRight: { label: 'ปิด' },
    }),
  )
}

const getWorkaroundButton = (session, dispatch) => {
  const workaround = getScormWorkaround(_.get(session, 'context.moduleUuid'))
  if (!workaround) return {}
  return {
    label: 'แสดงปุ่มเรียนใหม่',
    handleClick: () => dispatch(handleApplyScormWorkaround(workaround)),
  }
}

export const handleSubmitScormReport = (onSent) => async (dispatch) => {
  dispatch(loadingDialog())
  const session = getScormDebugSession()
  const workaroundButton = getWorkaroundButton(session, dispatch)
  try {
    if (!session) throw new Error('no scorm debug session')
    const { ref } = await session.report()
    onSent()
    dispatch(
      openDialog({
        iconType: 'success',
        title: 'ส่งข้อมูลแล้ว',
        message: [`รหัสอ้างอิง ${ref}`, 'กรุณาแจ้งรหัสนี้กับผู้ดูแลระบบ'],
        buttonLeft: {
          label: 'คัดลอกรหัส',
          handleClick: () => {
            copyText(ref)
            dispatch(closeDialog())
          },
        },
        buttonCenter: workaroundButton,
        buttonRight: { label: 'ปิด' },
      }),
    )
  } catch (e) {
    dispatch(
      openDialog({
        iconType: 'error',
        title: 'ส่งข้อมูลไม่สำเร็จ',
        message: ['กรุณาลองใหม่อีกครั้ง หรือแจ้งผู้ดูแลระบบ'],
        buttonCenter: workaroundButton,
        buttonRight: { label: 'ปิด' },
      }),
    )
  }
}

export const handleOpenScormReport = (onSent) => (dispatch) => {
  dispatch(
    openDialog({
      iconType: 'warning',
      title: 'หน้าจอค้างหรือไปต่อไม่ได้?',
      message: ['ระบบจะส่งข้อมูลการเรียนบทนี้ให้ผู้ดูแลระบบตรวจสอบ'],
      buttonLeft: { label: 'ยกเลิก' },
      buttonRight: {
        label: 'ส่งข้อมูล',
        handleClick: () => dispatch(handleSubmitScormReport(onSent)),
      },
    }),
  )
}
